import { IRoomWasCreated } from '../../../actions/bookingCalendar/room/requestCreateRoom'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IRoomWasCreated,
): IBookingCalendarStore {
  return {
    ...state,
    rooms: [
      ...state.rooms,
      {
        ...action.room,
        modified: 1,
        position: Number(action.room.position) + 1,
      },
    ],
  }
}
